import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { SettingProps } from "./Settings";

const IntroSettings = ({ setType, setStep }: SettingProps) => {
  return (
    <div className="wrapper">
      <div className="listWrap">
        <div className="buttonBorder">
          <button onClick={() => setType!("share")}>
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_share.svg`}
              alt="share"
            />
            <h1>차량 공유 설정</h1>
          </button>
        </div>
        <div className="buttonBorder">
          <button onClick={() => setType!("password")}>
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_password.svg`}
              alt="password"
            />
            <h1>비밀번호 설정</h1>
          </button>
        </div>
      </div>
    </div>
  );
};
export default IntroSettings;
